module.exports = __webpack_public_path__ + "img/lezhi02.b58e02a8.png";